import { call, put, takeEvery, select } from 'redux-saga/effects'

import constants from 'core/data-model/constants/defaults'
import { getSelectedDisplayProduct } from 'quick-quote/product-selection/selectors'

import { SELECTED_PRODUCT } from '../../product-selection/actions'

import { updateHealthCheckList, updateFinancialCheckList } from './actions'

/**
 * createProductLoanBenefitFunc
 * @param {ReturnType<import('core/service/loan/loan-document-list').createLoanDocumentListService>} loanDocumentListService
 */
export function createProductLoanBenefitFunc(loanDocumentListService) {
  function* onGetDocumentListRequest() {
    const displayProductQuery = yield select(getSelectedDisplayProduct)
    if (displayProductQuery.category !== constants.LOAN_PRODUCT_CATEGORY) return
    const financialDocumentList = yield call(loanDocumentListService.getFinancialDocument)
    const healthCheckList = yield call(loanDocumentListService.getHealthCheckItem)

    yield put(updateHealthCheckList(healthCheckList))
    yield put(updateFinancialCheckList(financialDocumentList))
  }

  return {
    onGetDocumentListRequest,
  }
}

/**
 * @param serviceWrapper {Awaited<ReturnType<import('core/service-wrapper/wrapper').buildServiceWrapper>>}
 */
export function* sagas(serviceWrapper) {
  const { LOAN } = serviceWrapper.products
  yield [takeEvery(SELECTED_PRODUCT, LOAN.onGetDocumentListRequest)]
}
